module.exports = __webpack_public_path__ + "img/offers8.277f94cb.jpg";